import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getImageUrl } from '../utils/imageUrl';
import SubmissionModal from '../components/SubmissionModal';
import './YouTube.css';

function YouTube() {
  const navigate = useNavigate();
  const [submissions, setSubmissions] = useState([]);
  const [filterSubscribers, setFilterSubscribers] = useState('all');
  const [filterNiche, setFilterNiche] = useState('all');
  const [filterLocation, setFilterLocation] = useState('all');
  const [selectedSubmission, setSelectedSubmission] = useState(null);

  useEffect(() => {
    fetchYouTubeSubmissions();
  }, []);

  const fetchYouTubeSubmissions = async () => {
    try {
      const response = await axios.get('/api/submissions/youtube');
      setSubmissions(response.data);
    } catch (error) {
      console.error('Error fetching YouTube submissions:', error);
    }
  };

  const filterSubmissions = () => {
    return submissions.filter(s => {
      const matchMetric = filterSubscribers === 'all' || s.subscribers === filterSubscribers;
      const matchNiche = filterNiche === 'all' || s.niche === filterNiche;
      const matchLocation = filterLocation === 'all' || s.location === filterLocation;
      return matchMetric && matchNiche && matchLocation;
    });
  };

  const renderPhotos = (photosStr) => {
    if (!photosStr) return null;
    try {
      const photos = JSON.parse(photosStr);
      if (photos.length === 0) return null;
      return (
        <div className="submission-photos">
          {photos.map((photo, idx) => (
            <img key={idx} src={getImageUrl(photo)} alt={`Submission ${idx + 1}`} className="photo-thumbnail" />
          ))}
        </div>
      );
    } catch (e) {
      return null;
    }
  };

  return (
    <div className="youtube-container">
      <div className="platform-page-header" style={{ background: 'linear-gradient(135deg, #ff0000 0%, #cc0000 100%)' }}>
        <button className="back-btn" onClick={() => navigate('/browse')}>← Back to Browse</button>
        <div className="platform-page-title">
          <span className="platform-page-emoji">▶</span>
          <h1>YouTube Channels</h1>
          <p>Discover video creators available for sponsorship</p>
        </div>
      </div>

      <div className="filter-section">
        <div className="filter-group">
          <label>Subscribers:</label>
          <select value={filterSubscribers} onChange={(e) => setFilterSubscribers(e.target.value)}>
            <option value="all">All</option>
            <option value="BELOW <10K">Below 10K</option>
            <option value="10-50K">10-50K</option>
            <option value="50-100K">50-100K</option>
            <option value="100-500K">100-500K</option>
            <option value="GREATER >500K">Greater 500K</option>
          </select>
        </div>
        <div className="filter-group">
          <label>Niche:</label>
          <select value={filterNiche} onChange={(e) => setFilterNiche(e.target.value)}>
            <option value="all">All Niches</option>
            <option value="Lifestyle">Lifestyle</option>
            <option value="Travel">Travel</option>
            <option value="Technology">Technology</option>
            <option value="Fitness">Fitness</option>
            <option value="Finance">Finance</option>
            <option value="Food and Cooking">Food and Cooking</option>
            <option value="Education">Education</option>
            <option value="Gaming">Gaming</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div className="filter-group">
          <label>Location:</label>
          <select value={filterLocation} onChange={(e) => setFilterLocation(e.target.value)}>
            <option value="all">All Locations</option>
            <option value="United States">United States</option>
            <option value="India">India</option>
            <option value="UK">UK</option>
            <option value="Europe">Europe</option>
            <option value="Rest of the World">Rest of the World</option>
          </select>
        </div>
      </div>

      <div className="submissions-grid">
        {filterSubmissions().length > 0 ? (
          filterSubmissions().map((submission) => (
            <div
              key={submission.id}
              className="submission-card"
              onClick={() => setSelectedSubmission(submission)}
              onKeyDown={(event) => event.key === 'Enter' && setSelectedSubmission(submission)}
              role="button"
              tabIndex="0"
            >
              <h3>{submission.channel_title}</h3>
              <p className="subscribers-badge">{submission.subscribers}</p>
              <div className="tags">
                {submission.niche && <span className="tag-badge tag-niche">{submission.niche}</span>}
                {submission.location && <span className="tag-badge tag-location">{submission.location}</span>}
              </div>
              {renderPhotos(submission.photos)}
              <p className="description">
                {(submission.channel_description || '').trim().slice(0, 180)}
                {(submission.channel_description || '').trim().length > 180 ? '...' : ''}
              </p>
              {(submission.channel_description || '').trim().length > 180 && (
                <button type="button" className="description-more" onClick={() => setSelectedSubmission(submission)}>
                  More
                </button>
              )}
              <div className="card-footer">
                <p><strong>Email:</strong> {submission.email}</p>
                <a href={submission.channel_url} target="_blank" rel="noopener noreferrer" className="visit-btn" onClick={(event) => event.stopPropagation()}>
                  Visit Channel
                </a>
              </div>
            </div>
          ))
        ) : (
          <p>No YouTube submissions yet.</p>
        )}
      </div>
      <SubmissionModal submission={selectedSubmission} platform="youtube" onClose={() => setSelectedSubmission(null)} />
    </div>
  );
}

export default YouTube;
